export const isWebView = () => {
  const { navigator } = window;
  const { userAgent } = navigator;
  const normalizedUserAgent = userAgent.toLowerCase();
  const { standalone } = navigator;

  const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /android/.test(normalizedUserAgent);
  const isSafari = /safari/.test(normalizedUserAgent);

  return (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari);
};

export const isSafariBrowser = () => {
  let userAgentString = window.navigator.userAgent;
  userAgentString = userAgentString.toLowerCase();
  const isChrome = userAgentString.indexOf('chrome') > -1;
  let isSafari = userAgentString.indexOf('safari') > -1;

  // Chrome contains the safari user agent aswell so set to false
  if (isChrome && isSafari) isSafari = false;
  return isSafari;
};

export default isWebView;
